import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import PlanoAssinaturaTab from './configuracoes/PlanoAssinaturaTab';
import PricingPage from './PricingPage';
export { billingOnly } from '../services/institutionAccess';

export default function InstitutionBillingGate() {
  const { authState, handleLogout, fetchAndUpdateSubscription } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const legal = authState.user?.can_regularize_subscription || authState.user?.role_key === 'representante_legal';
  if (legal && !['/configuracoes', '/pricing'].includes(location.pathname)) return <Navigate to="/configuracoes" replace />;
  return <Container className="py-4" style={{ maxWidth: 1100 }}>
    <div className="d-flex flex-wrap justify-content-between gap-3 align-items-center mb-4">
      <div><small className="text-muted">{authState.entidade?.nome}</small><h1 className="h3 mb-0">Plano e Assinatura</h1></div>
      <Button variant="outline-secondary" onClick={handleLogout}>Sair</Button>
    </div>
    {authState.requiresReauthentication ? <Alert variant="success">Assinatura regularizada. Saia e entre novamente para carregar todos os recursos da instituição. <Button onClick={handleLogout}>Entrar novamente</Button></Alert>
      : <Alert variant="warning">A instituição está inativada. {legal ? 'Regularize a assinatura para restabelecer o acesso à plataforma.' : 'Solicite ao Representante Legal a regularização da assinatura.'}</Alert>}
    {legal && <>
      <div className="d-flex gap-2 mb-3 flex-wrap"><Button variant="outline-primary" onClick={() => navigate('/configuracoes')}>Plano e Assinatura</Button><Button variant="outline-secondary" onClick={() => fetchAndUpdateSubscription()}>Verificar regularização</Button></div>
      {location.pathname === '/pricing' ? <PricingPage /> : <PlanoAssinaturaTab billingOnly />}
      <p className="small text-muted mt-3">A liberação depende da confirmação da assinatura pelo servidor. Se o pagamento já foi confirmado e o bloqueio persistir, solicite a revisão ao administrador.</p>
    </>}
  </Container>;
}
